import "./TextLink.css";
import { FlexInline } from "./Flex";
import Label from "./Label";

type Props = {
    href: string;
    target?: React.HTMLAttributeAnchorTarget;
    onClick?: () => void;
    children?: React.ReactNode;
};

function TextLink(props: Props) {
    const { href, target = "_blank", onClick, children } = props;
    const onLinkClick = onClick
        ? (event: React.MouseEvent<HTMLAnchorElement>) => {
              event.preventDefault();
              onClick();
          }
        : undefined;
    return (
        <a
            href={href}
            target={target}
            rel="noreferrer"
            className="web-lib__text-link"
            onClick={onLinkClick}
        >
            <FlexInline wrap="nowrap" gap="value8">
                <Label.Medium.MediumBold.Text1
                    nowrap
                    className="web-lib__text-link__label"
                >
                    {children}
                </Label.Medium.MediumBold.Text1>
            </FlexInline>
        </a>
    );
}

export default TextLink;
